// domain/common/Origin.ts
export class Origin {
  x: number;
  y: number;
  z: number;

  constructor(data: { x: number; y: number; z: number }) {
    this.x = data.x;
    this.y = data.y;
    this.z = data.z;
  }

  static fromObject(obj: Partial<Origin>): Origin {
    return new Origin({
      x: obj.x ?? 0,
      y: obj.y ?? 0,
      z: obj.z ?? 0,
    });
  }

  toObject(): Record<string, unknown> {
    return {
      x: this.x,
      y: this.y,
      z: this.z,
    };
  }
}

